import * as R from 'ramda'

import transact from 'src/lib/data/transact'

import dbSlice from 'src/store/db/slice'

import { setBanner } from 'src/store/action-methods/banner'
import { constants as bannerConstants } from 'src/components/generics/banner'

import * as dbSelectors from 'src/store/db/selectors'
import * as boardSelectors from 'src/store/selectors/board'

export const unPinPost = () => (dispatch, getState) => {
  const state = getState()
  const boardId = boardSelectors.boardIdSelector(state)
  const pinnedPostId = dbSelectors.pinnedPostSelector(state)
  dispatch(dbSlice.actions.removePinnedPost({ pinnedPostId, boardId }))
}

export const setDisabledEmojis =
  (disabledEmojisList, disabledBoardEmojis) => async (dispatch, getState) => {
    const state = getState()
    const boardId = boardSelectors.boardIdSelector(state)

    const disabledEmojiKeys = disabledEmojisList.map(R.prop('key'))
    const disabledBoardEmojiKeys = disabledBoardEmojis.map(R.prop('key'))
    const newlyDisabled = disabledEmojisList.filter(
      ({ key }) => !disabledBoardEmojiKeys.includes(key)
    )

    const newlyEnabled = disabledBoardEmojis.filter(
      ({ key }) => !disabledEmojiKeys.includes(key)
    )
    const hasChanged = newlyDisabled.length || newlyEnabled.length

    if (hasChanged) {
      const disabledEmojisJSON = JSON.stringify(disabledEmojisList)

      await transact([
        ['@board/disable-emoji', { disabledEmojisJSON, boardId }]
      ])

      dispatch(
        dbSlice.actions.setDisabledEmojis({ boardId, disabledEmojisJSON })
      )
    }

    if (hasChanged) {
      dispatch(
        setBanner({
          open: true,
          msg: 'Your emoji settings have been saved.'
        })
      )
    } else {
      dispatch(
        setBanner({
          open: true,
          msg: 'No changes detected',
          type: bannerConstants.types.WARNING
        })
      )
    }
  }

export const removePinnedPost = () => (dispatch, getState) => {
  const state = getState()
  const boardId = boardSelectors.boardIdSelector(state)
  const pinnedPostId = dbSelectors.pinnedPostSelector(state)
  dispatch(dbSlice.actions.removePinnedPost({ pinnedPostId, boardId }))
}
